import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=c20713d4&scoped=true&"
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"
import style0 from "./carousel.vue?vue&type=style&index=0&id=c20713d4&lang=scss&scoped=true&"
import style1 from "./carousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20713d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c20713d4')) {
      api.createRecord('c20713d4', component.options)
    } else {
      api.reload('c20713d4', component.options)
    }
    module.hot.accept("./carousel.vue?vue&type=template&id=c20713d4&scoped=true&", function () {
      api.rerender('c20713d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/carousel.vue"
export default component.exports